import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ScrollToTopButton from '../ui/ScrollToTopButton';

/**
 * Main layout component with Header and Footer
 * Used for all authenticated pages
 */
export default function Layout({ children, showHeader = true }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex flex-col">
      {showHeader && <Header />}

      <main className="flex-1">
        {children}
      </main>

      <Footer />

      {/* Scroll to top button - available on all pages */}
      <ScrollToTopButton />
    </div>
  );
}
